export default "__VITE_ASSET__4057bd5d__"